import {HasCode} from "../models/HasCode";

export const DollarOrPointsFilter = "dollarOrPoints";

export type DollarOrPointsFilter = (price: number| null, hasCode: HasCode) => string;

export function dollarOrPointsFilter(): DollarOrPointsFilter {
    return (price: number| null, hasCode: HasCode) => {
        if (price == null) {
            return "";
        }

        return (hasCode.code === "XJO")
                ? price.toFixed(1)
                : "$" + price.toFixed(3);
    };
}
